import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./StatementExchangeFooter.scss";

const StatementExchangeFooter: React.FC<{ totalPayout: number }> = ({
  totalPayout,
}) => {
  return (
    <div className="statement-exchange__footer">
      <div className="statement-exchange__footer__column">
        <FormattedMessage tagName="span" id="reports-total" />
      </div>
      <div className="statement-exchange__footer__column">
        <CurrencyNumber value={totalPayout} />
      </div>
    </div>
  );
};

export default StatementExchangeFooter;
